import Students from "../components/admin/Students";
import AdminDashboardLayout from "../components/AdminDashboardLayout";

function StudentsPage(){
    return(<AdminDashboardLayout>
        <Students/>
    </AdminDashboardLayout>)
}
export default StudentsPage